export enum JusticeSortOptions {
  'ACTIONS_REQUISES' = 'ACTIONS_REQUISES',
  'CLASSEMENT' = 'CLASSEMENT',
  'DATE_MISE_FOURRIERE' = 'DATE_MISE_FOURRIERE',
  'IMMATRICULATION' = 'IMMATRICULATION',
  'NATURE_MISE_EN_FOURRIERE' = 'NATURE_MISE_EN_FOURRIERE',
  'STATUT' = 'STATUT',
  'FOURRIERE' = 'FOURRIERE',
  'DECISION' = 'DECISION',
  'SORT_FINAL' = 'SORT_FINAL',
  'NUMERO_PARQUET' = 'NUMERO_PARQUET',
}
